import { APP_BASE_HREF, CurrencyPipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { enableProdMode, importProvidersFrom, provideZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';
import { APP_ROUTER_FEATURES, APP_ROUTES } from '@app/app.routes';
import 'moment/locale/ar.js';
import 'moment/locale/bg.js';
import 'moment/locale/cs.js';
import 'moment/locale/de.js';
import 'moment/locale/el.js';
import 'moment/locale/en-gb.js';
import 'moment/locale/es.js';
import 'moment/locale/fa.js';
import 'moment/locale/fi.js';
import 'moment/locale/fr.js';
import 'moment/locale/hr.js';
import 'moment/locale/hu.js';
import 'moment/locale/it.js';
import 'moment/locale/ka.js';
import 'moment/locale/lt.js';
import 'moment/locale/lv.js';
import 'moment/locale/mk.js';
import 'moment/locale/pl.js';
import 'moment/locale/ro.js';
import 'moment/locale/ru.js';
import 'moment/locale/sk.js';
import 'moment/locale/sr.js';
import 'moment/locale/tr.js';
import 'moment/locale/zh-cn.js';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// set the idp before the application start and instance the auth-provider
const urlSearchParams = new URLSearchParams(window.location.search);
const idp = urlSearchParams.get('i');
if (idp) {
  sessionStorage.setItem('idp', idp);
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    { provide: APP_BASE_HREF, useValue: '/tirepd' },
    // => provideRouter(APP_ROUTES, withDisabledInitialNavigation()),
    provideRouter(APP_ROUTES, ...APP_ROUTER_FEATURES),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    importProvidersFrom(...appConfig.imports),
    ...appConfig.providers,
    CurrencyPipe
  ]
})
  .then((_r) => {
    console.log('Application bootstrapped');
  })
  .catch((err) => console.error(err));
